var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Tag as AntTag } from 'antd';
import { Typography } from '../typography';
import styles from './Tag.module.css';
import clsx from 'clsx';
export var Tag = function (_a) {
    var children = _a.children, className = _a.className, _b = _a.state, state = _b === void 0 ? 'default' : _b, props = __rest(_a, ["children", "className", "state"]);
    var sortedColor = state === 'info' ? 'processing' : state;
    return (_jsx(AntTag, __assign({ className: clsx(styles.tag, className), color: sortedColor }, props, { children: children !== null && children !== void 0 ? children : _jsx(Typography, { children: state }, void 0) }), void 0));
};
